<template>
    <b-row>
        <b-col cols="12">
            <h3>{{ $t('evento.titulo_voucher') }}</h3>

            <div class="input-group">
                <input class="form-control w-auto" id="input-voucher" v-model="code" :placeholder="$t('formularios.cupon_descuento')" :disabled="(message && !error) || desactivar" />
                <button v-if="message && !error " :class="!esMovil ? 'button large-button' : 'button'" @click="remove" :disabled="desactivar">Quitar</button>
                <button v-else :class="!esMovil ? 'button large-button' : 'button'" @click="check" :disabled="desactivar || loading || loading_check || !code">{{ $t('formularios.verificar') }}</button>
            </div>

            <input class="form-control is-invalid" hidden />
            <span :class="{error: true, 'bg-success': !error}" v-if="message">{{ message }}</span>
        </b-col>
        <b-col cols="12" class="mt-3">
            <button :class="!esMovil ? 'button large-button' : 'button'" @click="continuar" :disabled="(message && !error) || desactivar || loading || loading_check">{{ $t('formularios.continuar_sin_cupon') }}</button>
            <button :class="!esMovil ? 'button large-button ml-2' : 'button ml-2'" @click="volver" :disabled="(message && !error) || desactivar || loading || loading_check">{{ $t('formularios.atras') }}</button>
        </b-col>
    </b-row>    
</template>

<script>
    export default {
        props: {
            sesion_id: {
                type: String,
                required: true
            },
            datos: {
                type: Array,
                required: true
            },
            desactivar: {
                type: Boolean,
                required: true
            },
            loading: {
                type: Boolean,
                required: true
            },
            esMovil: {
                type: Boolean
            }
        },
        data() {
            return {
                code: null,
                message: null,
                error: false,
                loading_check: false
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
        },
        methods: {
            remove() {
                this.code = null;
                this.message = null;
            },
            check() {
                this.loading_check = true;

                let data = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        lista_id: this.lista_abonados.id
                    },
                    sesion_id: this.sesion_id,
                    code: this.code,
                    datos: this.datos
                }
                this.$store.dispatch(this.config.getVuexAlias('front.abonados.compra.voucher'), data).then(res => {
                    this.message = res.data.message;
                    this.error = false;
                    this.continuar();
                }).catch(error => {
                    this.message = error.response.data.message;
                    this.error = true;
                }).finally(() => {
                    this.loading_check = false;
                });
            },
            continuar() {
                this.$emit('continuar');
            },
            volver() {
                this.$emit('volver');
            }
        }
    }
</script>